import $ from "jquery";
import 'inputmask/dist/jquery.inputmask.min'

(function() {

    if (!$('#profile-page').length) {
        return;
    }

const user_country = $('#profile-page').data('country');
$('.file-selection__input').on('change', function (e) {
    let filename = e.target.files[0].name;
    $(this).parents('.file-selection').find('.file-selection__name').text(filename);
});

$('[name=country_code]').on('change', function () {
    var country = $(this).val();
    $('#profile-page').attr('data-country', country);
    setMask(country);
});
setMask(user_country);

$('.country-dropdown .selector__item').on('click', function () {
    var country = $(this).val();
    $('#profile-page').attr('data-country', country);
    setMask(country);
});

function setMask(country) {
    var def = {
        inn: '999999999999',
        date: '99.99.9999',
        serial: '9999 999999',
        unit: '',
        inn_placeholder: '111111111111',
        serial_placeholder: '1111-222222',
        date_placeholder: 'дд.мм.гггг',
    };

    var masks = {
        RU: def,
        UA: {
            inn: '9999999999',
            serial: 'рр 999999',
            inn_placeholder: '1234567890',
            serial_placeholder: 'AA 333333',
        },
        KZ: {
            inn: '999999999999',
            serial: '',
            inn_placeholder: '123456789000',
            serial_placeholder: '',
        },
        BY: {
            inn: '9999999a999aa9',
            serial: 'рр 9999999',
            inn_placeholder: '1111111A111AB1',
            serial_placeholder: 'AA 3333333',
        },
        US: {
            inn: '999-99-9999',
            serial: 'a99999999',
            inn_placeholder: '111-11-1111',
            serial_placeholder: 'A33333333',
        }
    };

    masks['RU']['unit'] = '999-999';
    masks['RU']['unit_placeholder'] = '111-111';

    'RU' == country ? $('#unit').show() : $('#unit').hide();

    var pref = '[data-country="' + country + '"]';
    var keys = ['inn', 'date', 'serial', 'unit'];
    for (let key in keys) {
        var p = '';
        if (undefined !== masks[country][keys[key] + '_placeholder']) {
            var p = masks[country][keys[key] + '_placeholder'];
        }
        console.log(pref + " ." + keys[key])
        $(pref + " ." + keys[key]).attr('placeholder', p);
        $(pref + " ." + keys[key]).inputmask(undefined === masks[country][keys[key]] ? def[keys[key]] : masks[country][keys[key]]);
    }
}
})();

$('.userpic__file-input').on('change', function () {
    var form_data = new FormData();
    var file = $('.userpic__file-input').prop("files")[0];
    if (file) {
        form_data.append('photo', file);
        form_data.append('action', 'photo-upload');
    }

    var $userpic = $(this).parents('.profile-card__userpic').find('.userpic__image');

    $userpic.addClass('userpic_loading');
    $.ajax({
        url: '/profile', // point to server-side PHP script
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        success: function (response) {
            $userpic.removeClass('userpic_loading');
            if (response.success) {
                $userpic.attr('src', response.url);
                $('.userpic__setting').removeClass('userpic__setting_empty');
            } else {
                alert(response.error)
            }

        }
    });
});
$('.profile-card__img-remove').on('click', function () {
    $.get('profile?photo-delete').done(function () {
        $('.userpic__image').attr('src', '/img/userpic_big.svg');
        $('.userpic__setting').addClass('userpic__setting_empty');
    });
});
